/*
    filter 邏輯
    1. init(is_first=true) =>
        1. query_to_filter
        2. fetch_core_waybills
            1. filter_to_api_query
            2. axios
        if (is_first) {
            3. handle_quick_filter_key ui 決定要顯示哪個filter 樣式
        }
    2. filter() =>
        1. filter_to_query
        2. routes.push() 觸發 watch_routes()

    3. watch_routes() =>
        1. init(false)
 */
import moment from "moment"
const store = {
    namespaced: true,
    state: {
        current_form_entity_type: true,
        current_core_waybill: {},
        core_waybills: [],
        converters: [],
        current_page: 1,
        total_pages: 1,

        search_cache_key: null,
        quick_filters: {
            number: ["number", "operation_number", "original_number", "tracking_number"],
            info: ["consignee_name", "consignee_phone", "consignee_address", "note"],
        },
        quick_filter_key: {
            number: "number",
            info: "consignee_name",
        },
        filter_init: {
            page: 1,
            number: null,
            tracking_number: null,
            flight_number: null,
            sender_name: null,
            consignee_name: null,
            consignee_phone: null,
            consignee_address: null,
            note: null,
            is_used: null,
            created_at: {},
            shipping_date: {},
            operation: {
                number: null,
            },
            status: {
                scope: null,
                name: null,
                created_at: {},
            }
        },
        filter: {
            page: 1,
            status: {
                scope: null,
                name: null,
                created_at: {},
            },
        },
        tool_label: {
            core_waybill_length: 0,
            numbers: '',
            label_name: "",
        },
        is_show_filter: false,
        is_can_print_label: false,
        staffs: [],
    },
    getters: {
        // filter 平面化 輸出一層object
        filter_to_query(state, getters, rootState, rootGetters) {
            let filter = _.cloneDeep(state.filter)
            if (filter.page) delete filter.page

            if (filter.status.created_duration) {
                if (filter.status.created_duration[0]) filter.status_created_at_from = moment(filter.status.created_duration[0]).format("YYYY-MM-DD")
                if (filter.status.created_duration[1]) filter.status_created_at_to = moment(filter.status.created_duration[1]).format("YYYY-MM-DD")
            }

            if (filter.created_duration) {
                if (filter.created_duration[0]) filter.created_at_from = moment(filter.created_duration[0]).format("YYYY-MM-DD")
                if (filter.created_duration[1]) filter.created_at_to = moment(filter.created_duration[1]).format("YYYY-MM-DD")
            }

            if (filter.shipping_date_duration) {
                if (filter.shipping_date_duration[0]) filter.shipping_date_from = moment(filter.shipping_date_duration[0]).format("YYYY-MM-DD")
                if (filter.shipping_date_duration[1]) filter.shipping_date_to = moment(filter.shipping_date_duration[1]).format("YYYY-MM-DD")
            }

            if (filter.status_created_duration) delete filter.status_created_duration
            if (filter.shipping_date_duration) delete filter.shipping_date_duration
            if (filter.created_duration) delete filter.created_duration

            _.forEach(filter, (value, key) => {
                if (value && typeof value === 'object') {
                    _.forEach(value, (item_val, item_key) => {
                        if (filter[key][item_key]) {
                            filter[key+'_'+item_key] = item_val
                            delete filter[key][item_key]
                        }
                    })
                }
            })

            if (filter.status_created_duration) delete filter.status_created_duration
            if (filter.created_duration) delete filter.created_duration

            return object_delete_null(filter)
        },
        filter_to_api_query(state, getters, rootState, rootGetters) {
            return (payload = {}) => {
                let filter = _.cloneDeep(state.filter)

                if (payload.is_remove_page) {
                    if (filter.page) delete filter.page
                }

                if (filter.status.created_duration) {
                    if (filter.status.created_duration[0]) filter.status.created_at.from = date_to_start(filter.status.created_duration[0])
                    if (filter.status.created_duration[1]) filter.status.created_at.to = date_to_end(filter.status.created_duration[1])
                    delete filter.status.created_duration
                }

                if (filter.created_duration) {
                    if (filter.created_duration[0]) filter.created_at.from = date_to_start(filter.created_duration[0])
                    if (filter.created_duration[1]) filter.created_at.to = date_to_end(filter.created_duration[1])
                    delete filter.created_duration
                }

                if (filter.shipping_date_duration) {
                    if (filter.shipping_date_duration[0]) filter.shipping_date.from = date_to_start(filter.shipping_date_duration[0])
                    if (filter.shipping_date_duration[1]) filter.shipping_date.to = date_to_end(filter.shipping_date_duration[1])
                    delete filter.shipping_date_duration
                }

                // where_like add %% staring
                if (state.is_show_filter) {
                    _.forEach([
                        "number",
                        "flight_number",
                        "original_number",
                        "tracking_number",
                        "sender_name",
                        "sender_company_name",
                        "consignee_name",
                        "consignee_company_name",
                        "consignee_address",
                        "consignee_phone",
                        "note"
                    ], (name) => {
                        if (filter[name]) {
                            filter[name] = "%"+filter[name]+"%"
                        }
                    })

                    if (filter.operation.number) {
                        filter.operation.number = "%"+filter.operation.number+"%"
                    }
                }

                if (payload.merge) {
                    filter = {...filter, ...payload.merge}
                }

                return object_to_query(filter)
            }
        },
    },
    actions: {
        fetch_converters(context, payload) {
            if (context.state.converters.length) return Promise.resolve()
            var url = new RestUrl(context.rootState.customer.routes.api_v1_customer_file_converters).parse(
                {},
                "?pagination=false"
            )
            return axios.get(url, { headers: { Authorization: localStorage.getItem("customer_authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        context.commit('set_converters', response.data.converters);
                    } else {
                        return Promise.reject('fetch_converters')
                    }
                })
                .catch(error => {
                    console.log(error);
                    // return Promise.reject(
                    //     ResponseError(error)
                    // )
                })
        },
        fetch_core_waybills(context, payload = {}) {
            var that = this

            context.commit('set_tool_label', {
                core_waybill_length: 0,
                numbers: '',
                label_name: "",
            })

            var rest_url = new RestUrl(context.rootState.customer.routes.api_v1_customer_core_waybills_filter)
            var url = rest_url.parse(
                {},
            )

            url = `${url}?latest_status_scope=forwarder`
            let api_query = context.getters.filter_to_api_query()
            context.state.is_can_print_label = (api_query) ? true : false
            if (api_query) url += `&${api_query}`

            console.log(url);
            return axios.get(url, {headers: { Authorization: localStorage.getItem("customer_authentication_token") }})
                .then(response => {
                    context.commit('set_core_waybills', [])
                    if (response.data.status == "success") {
                        context.commit('set_search_cache_key', response.data.search_cache_key)
                        context.commit('set_core_waybills', response.data.core_waybills)
                        context.commit('set_pagination', response.data.pagination)

                        if (!response.data.core_waybills.length) {
                            return Promise.reject('fetch_core_waybills_no_anything_core_waybills')
                        }

                        if (payload.action == "edit") {
                            console.log('response.data.core_waybills[0]', response.data.core_waybills[0])
                            if (response.data.core_waybills.length) {
                                that.$router.push({
                                    name: 'edit_core_waybill',
                                    params: {identity: response.data.core_waybills[0].identity}
                                })
                            } else {
                                return Promise.reject('fetch_core_waybills_no_anything_core_waybills')
                            }
                        }
                    } else {
                        return Promise.reject('fetch_core_waybills_failure')
                    }
                })
        },
        fetch_core_waybills_pagination_false(context, payload) {
            console.log('fetch_core_waybills_pagination_false');
            let api_query = context.getters.filter_to_api_query({
                is_remove_page: true
            })

            if (!api_query) {
                context.commit('set_tool_label', {
                    core_waybill_length: 0,
                    numbers: '',
                    label_name: "",
                })
                return Promise.reject('fetch_core_waybills_pagination_false nothing filter')
            }

            var rest_url = new RestUrl(context.rootState.customer.routes.api_v1_customer_core_waybills_filter)
            var url = rest_url.parse(
                {},
            )

            url += "?pagination=false"
            if (api_query) url += `&${api_query}`

            return axios.get(url, {headers: { Authorization: localStorage.getItem("customer_authentication_token") }})
                .then(response => {
                    context.commit('set_tool_label', {
                        core_waybill_length: 0,
                        numbers: '',
                        label_name: '',
                    })

                    if (response.data.status == "success") {
                        console.log(_.groupBy(response.data.core_waybills, 'label_type'));
                        var label_name = _.groupBy(response.data.core_waybills, 'label_type')
                        var error, numbers, core_waybill_length = 0
                        // if (Object.keys(label_name) != "" && Object.keys(label_name).length == 1) {
                            let number_objects = []
                            
                            _.forEach(response.data.core_waybills, (e) => {
                                if (!isNaN(parseInt(e.note_2))) {
                                    for (let i = 1; i <= parseInt(e.note_2); i++) {
                                        number_objects.push(
                                            {
                                                number: e.number,
                                                count: parseInt(e.note_2),
                                                serial: i
                                            }
                                        )
                                    }
                                    core_waybill_length += parseInt(e.note_2);
                                } else {
                                    number_objects.push(
                                        {
                                            number: e.number,
                                            count: 1,
                                            serial: 1
                                        }
                                    )
                                    core_waybill_length += 1;
                                }
                            })
                            // core_waybill_length = response.data.core_waybills.length,
                            // numbers = _.map(response.data.core_waybills, 'number')
                            label_name = Object.keys(label_name)[0];

                            context.commit('set_tool_label', {
                                core_waybill_length: core_waybill_length,
                                numbers: number_objects,
                                label_name: label_name || "Label::Default",
                            })
                        // } else {
                        //     return Promise.reject('core_waybills_label_type_different')
                        // }
                    } else {
                        return Promise.reject('fetch_core_waybills_pagination_false_error')
                    }
                })
                .catch(error => {
                    return Promise.reject(
                        ResponseError(error)
                    )
                })
        },
        export_core_waybills(context, payload = {}) {
            var url = new RestUrl(context.rootState.customer.routes.api_v1_customer_core_waybills_export).parse(
                {search_cache_key: context.state.search_cache_key}
            )
            if (payload.converter_identity) {
                url += `?converter_identity=${payload.converter_identity}`
            }
            return axios.get(url, { headers: { Authorization: localStorage.getItem("customer_authentication_token") }})
                .then(response => {
                    console.log(response)
                    if (response.data.status == "success") {

                    } else {
                        return Promise.reject()
                    }
                })
        },
        clear_filter(context, payload) {
            context.commit('set_filter', _.cloneDeep(context.state.filter_init))

            if (payload.operation_identity) {
                context.commit('set_filter_kay_value', {
                    key: 'operation_identity',
                    value: payload.operation_identity
                })
            }
        },
        fetch_core_waybills_csv(context, payload) {
            let timestamp = Math.floor(Date.now() / 1000)
            let csv_tpye_string = payload.type ? "&csv_tpye="+payload.type : null
            var url = new RestUrl(context.rootState.customer.routes.api_v1_customer_core_waybills_filter + ".csv").parse(
                {},
                "?v=" + timestamp + (csv_tpye_string ? csv_tpye_string : '')
            )

            let to_api_query_parameters = {
                is_remove_page: true
            }
            if (payload.type == "clearance") {
                to_api_query_parameters.merge = {
                    material: {
                        class_names: 'House'
                    },
                    condition: {
                        polarity: 'true',
                    },
                    status: {
                        scope: 'forwarder',
                        name: '點交'
                    }
                }
            }

            let api_query = context.getters.filter_to_api_query(to_api_query_parameters)
            if (api_query) url += `&${api_query}`

            console.log(url);
            console.log(url);
            console.log(url);
            return axios.get(url, {headers: { Authorization: localStorage.getItem("customer_authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        var downloadLink = document.createElement("a")
                        var blob = new Blob(["\ufeff", response.data.csv])
                        var url = URL.createObjectURL(blob)
                        var file_name_note = payload.type == 'clearance' ? "_清關" : ""
                        downloadLink.href = url
                        downloadLink.download = moment().format('YYYY-MM-DD HH:mm:ss') + file_name_note + ".csv"
                        document.body.appendChild(downloadLink)
                        downloadLink.click()
                        document.body.removeChild(downloadLink)
                    } else if (response.data.status == "failure") {
                        return Promise.reject('fetch_core_waybills_svg_error')
                    }
                })
                .catch(error => {
                    return Promise.reject('fetch_core_waybills_svg_error')
                })
        },
        // query 轉成 filter格式 並 merge 到 filter
        handle_query_to_filter(context, payload = {}) {
            if (payload.query) {
                let query = {..._.cloneDeep(context.state.filter_init), ..._.cloneDeep(payload.query)}

                // {
                //     key: val,
                //     key: val,
                //     items: {
                //         item_key: item_val,
                //         item_key: item_val,
                //     }
                // }
                // 將filter_init 內的的object 轉換成 駝峰格式 並判斷有該query 則使用query的值
                _.forEach(context.state.filter_init, (value, key) => {
                    if (value && typeof value === 'object') {
                        _.forEach(value, (item_val, item_key) => {
                            if (query[key+'_'+item_key]) {
                                query[key][item_key] = query[key+'_'+item_key]
                                delete query[key+'_'+item_key]
                            }
                        })
                    }
                })

                if (query.status_created_at_from && query.status_created_at_to) {
                    query.status.created_duration = [
                        moment(query.status_created_at_from) || "",
                        moment(query.status_created_at_to) || ""
                    ]
                    delete query.status_created_at_from
                    delete query.status_created_at_to
                }

                if (query.created_at_from && query.created_at_to) {
                    query.created_duration = [
                        moment(query.created_at_from) || "",
                        moment(query.created_at_to) || ""
                    ]
                    delete query.created_at_from
                    delete query.created_at_to
                }

                if (query.shipping_date_from && query.shipping_date_to) {
                    query.shipping_date_duration = [
                        moment(query.shipping_date_from) || "",
                        moment(query.shipping_date_to) || ""
                    ]
                    delete query.shipping_date_from
                    delete query.shipping_date_to
                }

                context.state.filter = {...context.state.filter, ...query}
            }
        },
        // only run in init()
        handle_quick_filter_key(context, payload = {}) {
            let filter = object_delete_null(
                _.cloneDeep(context.state.filter)
            )
            if (filter.page) delete filter.page
            let filter_length = Object.keys(filter).length
            let quick_filter_keys_occurrence_number = {
                number: 0,
                number_last_key: "",
            }

            if(filter.operation && filter.operation.number) {
                quick_filter_keys_occurrence_number.number += 1
                quick_filter_keys_occurrence_number.number_last_key = 'operation_number'
            }
            context.state.quick_filters.number.forEach((key) => {
                if(filter[key]) {
                    quick_filter_keys_occurrence_number.number += 1
                    quick_filter_keys_occurrence_number.number_last_key = key
                }
            })

            if (quick_filter_keys_occurrence_number.number == 1) {
                context.state.quick_filter_key.number = quick_filter_keys_occurrence_number.number_last_key
            }

            if (
                filter_length >= 2 ||
                (
                    quick_filter_keys_occurrence_number.number == 0 &&
                    filter_length >= 1
                ) || (
                    quick_filter_keys_occurrence_number.number >= 2
                )
            ) {
                context.state.is_show_filter = true
            }
        },
        set_filter_init(context, payload) {
            context.commit('set_filter', _.cloneDeep(context.state.filter_init))
        },
        set_filter_kay_value(context, payload) {
            context.commit('set_filter_kay_value', payload)
        },
        set_is_show_waybill_filter(context, payload) {
            var boolean = (payload == true) ? true : false
            context.commit('set_is_show_waybill_filter', boolean)
        },
    },
    mutations: {
        set_core_waybills(state, payload) {
            state.core_waybills = payload
        },
        set_converters(state, payload) {
            state.converters = payload
        },
        set_staffs(state, payload) {
            state.staffs = payload
        },
        set_pagination(state, payload) {
            state.current_page = payload.current_page
            state.total_pages = payload.total_pages
        },
        set_tool_label(state, payload) {
            state.tool_label = payload
        },
        set_search_cache_key(state, payload) {
            state.search_cache_key = payload
        },
        set_is_show_waybill_filter(state, payload) {
            state.is_show_waybill_filter = payload
        },
        set_filter(state, payload) {
            state.filter = payload
        },
        set_filter_kay_value(state, payload) {
            state.filter[payload.key] = payload.value
        },
    }
}

export default store
